import React, { useEffect, useState } from 'react';
import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import {
  withAuth0,
  withAuthenticationRequired,
  useAuth0,
} from '@auth0/auth0-react';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import ProtectedRoutes from './ProtectedRoutes';
import { NoAccessPage, LoadingPage } from 'cj-common-react';
import ErrorPage from '../components/ErrorPage';
import {
  config,
  LD_LOCAL_USER_KEY,
  USER_AUTHORIZATION_NAMESPACE_KEY,
  ERROR_PAGE_ENUMS,
} from '../config';
const { LAUNCH_DARKLY_INIT_FAILURE } = ERROR_PAGE_ENUMS;

function ProtectedLDWrapper({ userLocation }) {
  const { user } = useAuth0();
  const authorization = user?.[USER_AUTHORIZATION_NAMESPACE_KEY];

  return (
    <>
      {user && (
        <LDProvider
          clientSideID={config.LAUNCH_DARKLY_CLIENT_ID}
          user={{
            key:
              config.ENVIRONMENT === 'local'
                ? LD_LOCAL_USER_KEY
                : user?.sub || '',
            custom: {
              memberName: authorization?.member_name || '',
              memberDisplayName: authorization?.member_display_name || '',
            },
            email: user?.email || '',
          }}
          options={{
            hash:
              config.ENVIRONMENT === 'local'
                ? config.LAUNCH_DARKLY_HASH
                : authorization?.ldHash,
          }}
        >
          <Protected user={user} userLocation={userLocation} />
        </LDProvider>
      )}
    </>
  );
}

function Protected({ userLocation }) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const ldFeatureFlags = useFlags();
  const ldClient = useLDClient();

  useEffect(() => {
    async function waitForLdInitialization() {
      try {
        await ldClient.waitForInitialization();
        setIsLoading(false);
      } catch (err) {
        console.error('Failed to initialize LaunchDarkly', err);
        setHasError(true);
        setIsLoading(false);
      }
    }
    if (!ldClient) {
      return;
    }
    waitForLdInitialization();
  }, [ldClient]);

  if (hasError) {
    return <ErrorPage error={LAUNCH_DARKLY_INIT_FAILURE} />;
  }

  if (isLoading) {
    return <LoadingPage />;
  }

  if (ldFeatureFlags.showCjChat === false) {
    return (
      <NoAccessPage
        handleClick={() => window.location.replace(config.CJ_HOME_BASE_URL)}
      />
    );
  }
  return (
    <ProtectedRoutes
      featureFlags={ldFeatureFlags}
      userLocation={userLocation}
    />
  );
}
export default withAuthenticationRequired(withAuth0(ProtectedLDWrapper), {
  onRedirecting: () => <LoadingPage />,
});
